import { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { User, Building2 } from "lucide-react";
import { ArrowLeft } from "lucide-react";
import { ArrowRight } from "lucide-react";
import kycimage1 from "../assets/Illustration.png"


import { toast } from "react-toastify";
import Aggrement from "./Aggreement";
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const steps = [
  "Business type",
  "Billing Information",
  "Bank Details",
  "Document Verification",
  "Aggrement",
];

const BusinessTypeSelection = () => {
  const [selectedType, setSelectedType] = useState("individual");
  const [currentStep, setCurrentStep] = useState(0);
  const [isBankVerified, setIsBankVerified] = useState(false);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [isGstinVerified, setIsGstinVerified] = useState(false);
  const [isBillingVerified, setIsBillingVerified] = useState(false);
  const [gstNumber, setGstNumber] = useState("");
  const [aadhaar, setAadhaar] = useState({});
  const [pan, setPan] = useState({});
  const [bank, setBank] = useState({});
  const [gst, setGst] = useState({});
  const [aadhaarNo, setAadhaarNo] = useState("")

  const [companyAddress, setCompanyAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const navigate = useNavigate();



  const [billingInfo, setBillingInfo] = useState({
    address: "",
    city: "",
    state: "",
    postalCode: "",
  });
  const [bankDetails, setBankDetails] = useState({
    refId: "",
    branchName: "",
    city: "",
    bankName: "",
    accountNumber: "",
    ifsc: "",
  });
  const [documentDetails, setDocumentDetails] = useState({
    aadharNo: "",
    otp: "",
    name: "",
    guardianName: "",
    address: "",
    state: "",
    pan: "",
    panName: "",
    panType: "",
  });

  const [otp, setOtp] = useState(""); // State for OTP input
  const [isOtpSent, setIsOtpSent] = useState(false); // To track if OTP was sent
  const [isOtpVerified, setIsOtpVerified] = useState(false); // To track OTP verification status
  const [errors, setErrors] = useState({});
  const [session, setSession] = useState("");
  const payload = {
    selectedType,
    billingInfo,
    bankDetails,
    documentDetails,
    gstNumber,
    isVerified,
  };
  const [next, setNext] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    const token = document.cookie;
    // console.log(token)
    //   const token=getTokens()
    if (token) {
      setSession(token);
    }
    if (isAadharVerified && isPanVerified && isBankVerified) {
      setIsVerified(true)
    }
  });

  const handleChecked = (e) => {
    setChecked(e.target.checked);
  }


  const handleBiling = async () => {
    if (validateBillingInfo()) {
      setNext(true)

      try {
        // console.log("hiii")
        const [session, token] = document.cookie.split("=");
        const response = await axios.post(
          `${REACT_APP_BACKEND_URL}/merchant/verfication/billing-info`,
          { billingInfo },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        toast.success("Billing info saved successfully!")
        setIsBillingVerified(true)
        console.log("biling", response.data);
      } catch (error) {
        console.log("Error in billing info", error)
      }


      console.log("billing info", billingInfo);
    }
  }


  const handleSendOtp = async () => {
    setIsLoading(true); // Start loading

    try {
      await sendAadhaarOtp(); // Call the actual API function
    } catch (error) {
      console.error("Error sending OTP:", error);
    }

    setIsLoading(false); // Stop loading after API call
  };

  const handleVerify = async (value) => {
    if (value === "pan") {
      setIsVerifying(true);
      try {
        await verifyPAN(); // Call the actual API function
      } catch (error) {
        console.error("Error verifying PAN:", error);
      }

      setIsVerifying(false); // Stop loading after API call
    }
    else if (value === "aadhar") {
      console.log("aadhar")
      setIsVerifying(true);
      try {
        await verifyAadhaarOtp(); // Call the actual API function
      } catch (error) {
        console.error("Error verifying Aadhar:", error);
      }

      setIsVerifying(false); // Stop loading after API call
    }
    else if (value === "bank") {
      setIsVerifying(true);
      try {
        await verifyBank(); // Call the actual API function
      } catch (error) {
        console.error("Error verifying Bank:", error);
      }

      setIsVerifying(false); // Stop loading after API call
    }
    else if (value === "gst") {
      setIsVerifying(true);
      try {
        await verifyGstin(); // Call the actual API function
      } catch (error) {
        console.error("Error verifying GSTIN:", error);
      }

      setIsVerifying(false);
    }

  }



  useEffect(() => {
    // this is for Aadhaar
    const fetchAllData = async () => {
      try {
        const [session, token] = document.cookie.split("=");
        //billing
        const response_billing = await axios.get(
          `${REACT_APP_BACKEND_URL}/getKyc/getBillingInfo`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        // console.log(response_billing.status)
        setBillingInfo({
          ...billingInfo,
          address: response_billing.data.address || "", // Ensure a fallback if undefined
          city: response_billing.data.city || "",
          state: response_billing.data.state || "",
          postalCode: response_billing.data.postalCode || "",
        })
        if (response_billing.data.address) {
          setIsBillingVerified(true)
        }
        //aadhar
        const response_a = await axios.get(
          `${REACT_APP_BACKEND_URL}/getKyc/getAadhaar`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response_a.data)

        setDocumentDetails((prevDetails) => ({
          ...prevDetails,
          aadharNo: response_a.data.aadhaarNumber || "",
          guardianName: response_a.data.sonOf || "",
          name: response_a.data.name || "",
          address: response_a.data.address || "",
          state: response_a.data.state || "",
        }));
        setAadhaar(response_a.data);
        // setAadhaarNo(response_a.data.aadhaarNumber)
        console.log("document details", documentDetails)
        // console.log(aadhaar)
        if (response_a.data.aadhaarNumber) {
          setIsAadharVerified(true)
        }
        //pan
        const response_p = await axios.get(
          `${REACT_APP_BACKEND_URL}/getKyc/getPan`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log(response_p.data)
        setDocumentDetails((prevDetails) => ({
          ...prevDetails,
          pan: response_p.data.pan || "",
          panName: response_p.data.nameProvided || "",
          panType: response_p.data.panType || "",
        }));
        setPan(response_p.data);

        if (response_p.data.pan) {
          setIsPanVerified(true)
        }
        //bank account

        const response_b = await axios.get(
          `${REACT_APP_BACKEND_URL}/getKyc/getBankAccount`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log(response_b.data)
        setBank(response_b.data);
        setBankDetails({
          ...bankDetails,
          bankName: response_b.data.bank || "", // Ensure a fallback if undefined
          branchName: response_b.data.branch || "",
          city: response_b.data.city || "",
          nameAtBank: response_b.data.nameAtBank || "",
          accountNumber: response_b.data.accountNumber || "", // Fix here
          ifsc: response_b.data.ifsc || "", // Fix here
        });

        if (response_b.data.accountNumber) {
          setIsBankVerified(true)
        }

        //GST
        const response_g = await axios.get(
          `${REACT_APP_BACKEND_URL}/getKyc/getGST`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setGst(response_g.data);
        setGstNumber(response_g.data.gstin || "");
        setCompanyAddress(response_g.data.address || "");
        setCity(response_g.data.city || "");
        setState(response_g.data.state || "");
        setPincode(response_g.data.pincode || "");
        if (response_g.data.gstin) {
          setIsGstinVerified(true)
        }
        console.log(response_g.data)
      } catch (error) {
        toast.error("it getting some error to fetching data")

      }
    };
    fetchAllData();
  }, []);

  const handleNext = async () => {
    setNext(true)
    // if (currentStep === 1) return;
    if (currentStep === 2 && !isBankVerified) return;
    if (currentStep === 3 && (!isAadharVerified || !isPanVerified)) return;
    if (currentStep === 4 && !checked) {
      toast.error("Please check your agreement before proceeding!");
      return;
    }
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      console.log({ selectedType, billingInfo, bankDetails, documentDetails });

      try {

        console.log(payload)
        const [sessions, token] = session.split("=");

        const response = await axios.post(
          `${REACT_APP_BACKEND_URL}/merchant/verfication/kyc`,
          { payload },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success("KYC details submitted successfully!")

          navigate("/dashboard");
        } else {

          // alert(response.data.message || "Failed to submit KYC details!");
        }
      } catch (error) {
        // console.log("Error submitting KYC details", error);
        toast.error(error.response.data.message || "Failed to submit KYC details!")
      }
    }
  };
  const validateBillingInfo = () => {
    let newErrors = {};
    {
      Object.keys(newErrors).map((key) => (
        <p key={key} className="text-red-500 text-[12px] font mt-1">
          {newErrors[key]}
        </p>
      ))
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const verifyAadhaarOtp = async () => {
    // console.log("hi")
    try {
      // setLoadingState(prev => ({ ...prev, aadhaarVerifying: true }));
      const [sessions, token] = session.split("=");

      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/merchant/verfication/verify-otp`,
        {
          otp: documentDetails.otp,
          refId: documentDetails.refId,
          aadhaarNo: documentDetails.aadharNo,
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )


      if (response?.data?.success) {
        setIsOtpVerified(true);
        setIsAadharVerified(true);
        setDocumentDetails({
          ...documentDetails,
          name: response.data.data.name,
          guardianName: response.data.data.sonOf,
          address: response.data.data.address,
          state: response.data.data.state,
        });
        console.log(response.data);

        // setVerificationState(prev => ({ ...prev, isAadhaarVerified: true }));
        toast.success("Aadhaar OTP verified successfully!")
      } else {
        console.log("otp not verified");
      }
    } catch (error) {
      console.log("Error verifying Aadhaar OTP", error);
      toast.error("OTP verification failed!")

    } finally {
      // setIsAadhaarOtpSent(false);
      // setLoadingState(prev => ({ ...prev, aadhaarVerifying: false }));
    }
  };

  const sendAadhaarOtp = async () => {
    try {
      // setLoadingState(prev => ({ ...prev, aadhaarOtpSending: true }));
      const [sessions, token] = session.split("=");
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/merchant/verfication/generate-otp`,
        {
          aadhaarNo: documentDetails.aadharNo,
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data);

      if (response.data.data.ref_id) {
        setIsOtpSent(true);
        setDocumentDetails({
          ...documentDetails,
          refId: response.data.data.ref_id,
        });
        // setVerificationState(prev => ({ ...prev, isAadhaarOtpSent: true }));
        // setIsAadhaarOtpSent(true);
        // console.log("aadhaar otp sent successfully");
        toast.success(response.data.message)



      } else {
        console.log(response.data.message);
        toast.error(response.data.message)

      }
    } catch (error) {
      console.log("Error sending Aadhaar OTP", error);
      toast.error(error?.response?.data?.message)

    } finally {
      // setLoadingState(prev => ({ ...prev, aadhaarOtpSending: false }));
    }
  };

  const verifyGstin = async () => {
    if (!gstNumber) {
      toast.error("Please enter GST number!")

      return;
    }

    const [sessions, token] = session.split("=");
    try {
      // setLoadingState(prev => ({ ...prev, gstVerifying: true }));

      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/merchant/verfication/gstin`,
        {
          GSTIN: gstNumber,
          // businessName: "ShipEx",
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        console.log(response.data);
        setIsGstinVerified(true);
        setCompanyAddress(response.data.data.address);
        setCity(response.data.data.city);
        setState(response.data.data.state);
        setPincode(response.data.data.pincode);
        toast.success("GST Verified Successfully")
      } else {

        toast.error(response?.data?.message || "GST verification failed!")
      }
    } catch (error) {
      console.log("Error verifying GST", error);
      toast.error(error.response.data.message)

    } finally {
      // setLoadingState(prev => ({ ...prev, gstVerifying: false }));
    }
  };

  const verifyBank = async () => {
    // e.preventDefault();

    const [sessions, token] = session.split("=");

    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/merchant/verfication/bank-account`,
        {
          accountNo: bankDetails.accountNumber,
          ifsc: bankDetails.ifsc,
          // name: bankDetails.beneficiaryName,
          // phone: bankDetails.mobileNo,
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("Account verification response", response.data);

      if (response.data.success) {
        console.log(response.data.data);
        setBankDetails({
          ...bankDetails,
          bankName: response.data.data.bank,
          branchName: response.data.data.branch,
          city: response.data.data.city,
          nameAtBank: response.data.data.nameAtBank
        });

        setIsBankVerified(true);
        toast.success("bank account is verified")

        // setMessage({ account: response.data.message });
      } else {
        // setMessage({ account: response.data.message });
      }
    } catch (error) {
      toast.error("Error verifying account")
      console.log("Error verifying account", error);
    }
    // setIsVerifying(false);
  };

  const verifyPAN = async () => {
    if (!documentDetails.pan) {
      toast.error("Please enter PAN number and holder name!")

      return;
    }
    // console.log(session)
    const [sessions, token] = session.split("=");
    // console.log(token)
    try {
      // setLoadingState(prev => ({ ...prev, panVerifying: true }));
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/merchant/verfication/pan`,
        {
          pan: documentDetails.pan,
          // name: panHolderName
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        console.log(response.data);
        setDocumentDetails({
          ...documentDetails,
          panName: response.data.data.nameProvided,
          panType: response.data.data.panType,
        });
        setIsPanVerified(true);
        // setIsVerified(true);
        // setVerificationState(prev => ({ ...prev, isPanVerified: true }));
        toast.success("PAN verified successfully!")

      } else {
        // alert(response?.data?.message || "PAN verification failed!");
      }
    } catch (error) {
      console.log("Error verifying PAN", error);
      toast.error("PAN verification failed!")

    } finally {
      // setLoadingState(prev => ({ ...prev, panVerifying: false }));
    }
  };

  return (
    <div className="">
      {/* Step Progress Bar */}
      <div className="flex flex-col sm:flex-row justify-center sm:items-center font-semibold mb-6 gap-6 sm:gap-48 h-auto mt-10">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex items-start sm:items-center gap-3 sm:gap-0 flex-row sm:flex-col relative"
          >
            {/* Circle Indicator */}
            <div
              className={`w-8 h-8 flex items-center justify-center text-[14px] font-semibold rounded-full border-2 shrink-0
          ${index === currentStep
                  ? "bg-[#0CBB7D] text-white border-[#0CBB7D]"
                  : "border-gray-300 text-gray-500"}
        `}
            >
              {index + 1}
            </div>

            {/* Vertical Line for mobile */}
            {index !== steps.length - 1 && (
              <div className="sm:hidden h-6 w-[2px] bg-gray-300 absolute left-[14px] top-8" />
            )}

            {/* Label */}
            <span
              className={`text-[14px] font-normal sm:mt-2 text-left sm:text-center
          ${index === currentStep ? "text-[#0CBB7D]" : "text-gray-500"}
        `}
            >
              {step}
            </span>
          </div>
        ))}
      </div>
      <div
        className={`w-full flex flex-col justify-center text-[14px] font-bold  items-center ${currentStep === 1 ? "p-2 sm:p-4" : "p-2 sm:p-6 lg:p-10  "
          } gap-6`}
      >
        <div className="w-full max-w-full bg-white rounded-lg sm:p-4 md:p-6">
          {currentStep === 0 && (
            <>
              <h2 className="text-[14px] font-semibold mb-4 text-gray-800 text-center sm:text-left">
                Please Confirm Your Business Type
              </h2>

              <div className="flex flex-col sm:flex-row gap-4 mb-4 justify-center items-center sm:items-start">
                {[
                  { label: "Individual", value: "individual", icon: <User size={20} /> },
                  { label: "Company", value: "company", icon: <Building2 size={20} /> },
                ].map((option) => (
                  <div
                    key={option.value}
                    className={`relative z-[-20px] flex flex-col items-center justify-center border-2 rounded-lg p-6 w-40 cursor-pointer transition duration-200 ease-in-out ${selectedType === option.value
                        ? "border-[#0CBB7D] bg-green-50"
                        : "border-gray-300"
                      }`}
                    onClick={() => setSelectedType(option.value)}
                  >
                    {/* White circular icon container with green icon */}
                    <div className="w-12 h-12 rounded-full bg-[#0CBB7D] flex items-center justify-center text-white shadow-md">
                      {option.icon}
                    </div>
                    <span className="mt-2 font-semibold text-[14px]">{option.label}</span>
                  </div>
                ))}
              </div>
            </>
          )}

          {currentStep === 1 && (
            <div className="lg:w-full max-w-full ">
              <h2 className="text-[14px] text-[#0CBB7D] font-semibold mb-3">
                Billing Information
              </h2>

              {selectedType === "individual" && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-4 md:px-0">
                  {/* Left Side: Form Card */}
                  <div className="md:col-span-2 flex flex-col items-center md:mt-0 mt-4">
                    <div className="w-full max-w-[600px] md:max-w-full">
                      <div
                        className="bg-white sm:p-2 md:p-8 lg:p-7 rounded-md max-w-[700px]
      md:shadow-[0_2px_6px_rgba(12,187,125,0.2)]
      lg:shadow-[0_2px_8px_rgba(12,187,125,0.3)]
      relative"
                      >
                        <div
                          className={`grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 mt-2 ${isBillingVerified ? "pointer-events-none opacity-50" : ""
                            }`}
                        >
                          {Object.keys(billingInfo).map((key) => (
                            <div key={key} className="flex flex-col">
                              <label className="font-medium text-[14px] text-gray-700 mb-1">
                                {key.charAt(0).toUpperCase() + key.slice(1)}
                              </label>
                              <input
                                type="text"
                                className={`w-full p-[6px] text-[14px] font-normal border border-gray-300 rounded-md outline-none focus:ring-1 focus:ring-[#0CBB7D] text-gray-700 ${isBillingVerified ? "opacity-50 cursor-not-allowed" : ""}`}
                                value={billingInfo[key]}
                                onChange={(e) =>
                                  setBillingInfo({
                                    ...billingInfo,
                                    [key]: e.target.value,
                                  })
                                }
                                readOnly={isBillingVerified}
                                disabled={isBillingVerified}
                              />

                              {errors[key] && (
                                <span className="text-red-500 text-[13px] mt-1">
                                  {errors[key]}
                                </span>
                              )}
                            </div>
                          ))}
                        </div>

                        {/* Save Button */}
                        <div className="flex justify-end mt-4">
                          <button
                            onClick={handleBiling}
                            disabled={isBillingVerified}
                            className={`text-white text-[12px] py-2 px-5 rounded-md transition-all duration-200 ${isBillingVerified
                                ? "bg-[#0CBB7D] cursor-not-allowed"
                                : "bg-[#0CBB7D] hover:bg-[#0aa66c]"
                              }`}
                          >
                            {isBillingVerified ? "Saved" : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>




                  {/* Right Side: Image (Hidden on Mobile) */}
                  <div className="hidden md:flex items-center justify-center">
                    <div className="lg:p-5 md:p-10 rounded-xl w-full max-w-[600px] md:-ml-[100px]">
                      <img
                        src={kycimage1}
                        alt="Billing Visual"
                        className="w-full h-auto max-h-[380px] object-contain rounded-md"
                      />
                    </div>
                  </div>
                </div>
              )}


              {selectedType === "company" && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-4 md:px-0">

                  {/* Left Side: Form */}
                  <div className="md:col-span-2 flex flex-col items-center md:mt-0 mt-4">
                    <div className="w-full max-w-[600px] md:max-w-full">
                      <div
                        className="bg-white sm:p-2 md:p-8 lg:p-7 rounded-md max-w-[700px]
          md:shadow-[0_2px_6px_rgba(12,187,125,0.2)]
          lg:shadow-[0_2px_8px_rgba(12,187,125,0.3)]
          relative"
                      >
                        {(isLoading || isVerifying) && (
                          <div className="absolute inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10 rounded-lg">
                            <span className="text-white text-[14px] font-semibold">Processing...</span>
                          </div>
                        )}

                        <h3 className="text-[14px] font-semibold mb-4 text-[#0CBB7D]">GSTIN Verification</h3>

                        <div
                          className={`grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 mt-2 ${isLoading || isVerifying ? "pointer-events-none opacity-50" : ""}`}
                        >
                          {/* GST Number */}
                          <div className="flex flex-col gap-2">
                            <label className="text-[14px] font-normal">GST Number</label>
                            <input
                              type="text"
                              placeholder="GSTIN"
                              className="w-full p-[7px] text-[14px] placeholder:text-[12px] border border-gray-300 rounded-md font-normal focus:outline-none focus:ring-1 focus:ring-[#0aa66d]"
                              value={gstNumber}
                              onChange={(e) => setGstNumber(e.target.value)}
                              readOnly={isGstinVerified}
                              disabled={isGstinVerified}
                            />
                          </div>

                          {/* Verify Button */}
                          <div className="flex items-end">
                            <button
                              onClick={() => handleVerify("gst")}
                              disabled={isGstinVerified}
                              className={`text-white text-[12px] py-2 px-5 rounded-md h-[34px] ${isGstinVerified ? "bg-[#0CBB7D] cursor-not-allowed" : "bg-[#0CBB7D] hover:bg-[#0aa66c]"
                                }`}
                            >
                              {isGstinVerified ? "Verified" : "Verify"}
                            </button>
                          </div>

                          {/* Row 1: Company Address & City */}
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:col-span-2">
                            {/* Company Address */}
                            <div className="flex flex-col gap-2">
                              <label className="text-[14px] font-normal">Company Address</label>
                              <input
                                type="text"
                                placeholder="Company address"
                                className="w-full text-gray-700 text-[14px] font-normal placeholder:text-[12px] bg-gray-100 p-[7px] rounded-md"
                                value={companyAddress}
                                readOnly
                                disabled
                              />
                            </div>

                            {/* City */}
                            <div className="flex flex-col gap-2">
                              <label className="text-[14px] font-normal">City</label>
                              <input
                                type="text"
                                placeholder="City"
                                className="w-full text-gray-700 text-[14px] font-normal placeholder:text-[12px] bg-gray-100 p-[7px] rounded-md"
                                value={city}
                                readOnly
                                disabled
                              />
                            </div>
                          </div>

                          {/* Row 2: State & Pincode */}
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:col-span-2 mt-4">
                            {/* State */}
                            <div className="flex flex-col gap-2">
                              <label className="text-[14px] font-normal">State</label>
                              <input
                                type="text"
                                placeholder="State"
                                className="w-full text-gray-700 text-[14px] font-normal placeholder:text-[12px] bg-gray-100 p-[7px] rounded-md"
                                value={state}
                                readOnly
                                disabled
                              />
                            </div>

                            {/* Pincode */}
                            <div className="flex flex-col gap-2">
                              <label className="text-[14px] font-normal">Pincode</label>
                              <input
                                type="text"
                                placeholder="Pincode"
                                className="w-full text-gray-700 text-[14px] font-normal placeholder:text-[12px] bg-gray-100 p-[7px] rounded-md"
                                value={pincode}
                                readOnly
                                disabled
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Side: Image */}
                  <div className="hidden md:flex items-center justify-center md:mt-0 lg:-mt-20 md:-ml-[80px]
    " >
                    <div className="lg:p-5 md:p-10 rounded-xl w-full max-w-[600px] mr-10">
                      <img
                        src={kycimage1}
                        alt="Billing Visual"
                        className="w-full h-auto max-h-[500px] object-contain rounded-md"
                      />
                    </div>
                  </div>

                </div>
              )}
            </div>
          )}
          {currentStep === 2 && (
            <div className="w-full max-w-full lg:-mt-10 md:mt-0">
              <h2 className="text-[14px] text-[#0CBB7D] font-semibold mb-3">Bank Details</h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:px-0 items-start">
                {/* Left Section */}
                <div className="md:col-span-2 flex flex-col items-start">
                  <div className="w-full max-w-[700px]">
                    <div className="bg-white lg:p-8 md:p-6 rounded-md lg:shadow-[0_2px_8px_rgba(12,187,125,0.3)] relative">
                      {(isLoading || isVerifying) && (
                        <div className="absolute inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10 rounded-md">
                          <span className="text-white text-[12px] font-semibold">Processing...</span>
                        </div>
                      )}

                      <div className={`grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6 ${isLoading || isVerifying ? "pointer-events-none opacity-50" : ""}`}>
                        {/* Row 1 */}
                        <div className="flex flex-col">
                          <label className="text-[14px] font-normal mb-[2px]">Account Number</label>
                          <input
                            type="text"
                            placeholder="Account no"
                            className="w-full p-[6px] !text-[14px] !font-normal placeholder:text-[12px] border border-gray-300 rounded-md outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                            value={bankDetails.accountNumber}
                            onChange={(e) => setBankDetails({ ...bankDetails, accountNumber: e.target.value })}
                            readOnly={isBankVerified}
                            disabled={isBankVerified}
                          />
                        </div>
                        <div className="flex flex-col">
                          <label className="text-[14px] font-normal mb-[2px]">IFSC Code</label>
                          <input
                            type="text"
                            placeholder="IFSC Code"
                            className="w-full p-[6px] !text-[14px] !font-normal placeholder:text-[12px] border border-gray-300 rounded-md outline-none focus:ring-1 focus:ring-[#0CBB7D]"
                            value={bankDetails.ifsc}
                            onChange={(e) => setBankDetails({ ...bankDetails, ifsc: e.target.value })}
                            readOnly={isBankVerified}
                            disabled={isBankVerified}
                          />
                        </div>

                        {/* Row 2 */}
                        <div className="flex flex-col">
                          <label className="text-[14px] font-normal mb-[2px]">Beneficiary Name</label>
                          <input
                            type="text"
                            placeholder="Beneficiary Name"
                            className="w-full p-[6px] !text-[14px] !font-normal placeholder:text-[12px] text-gray-600 bg-gray-200 border border-gray-300 rounded-md cursor-not-allowed"
                            value={bankDetails.nameAtBank}
                            readOnly
                            disabled
                          />
                        </div>
                        <div className="flex flex-col">
                          <label className="text-[14px] font-normal mb-[2px]">Bank Name</label>
                          <input
                            type="text"
                            placeholder="Bank Name"
                            className="w-full p-[6px] !text-[14px] !font-normal placeholder:text-[12px] text-gray-600 bg-gray-200 border border-gray-300 rounded-md cursor-not-allowed"
                            value={bankDetails.bankName}
                            readOnly
                            disabled
                          />
                        </div>

                        {/* Row 3 */}
                        <div className="flex flex-col">
                          <label className="text-[14px] font-normal mb-[2px]">Branch Name</label>
                          <input
                            type="text"
                            placeholder="Branch Name"
                            className="w-full p-[6px] !text-[14px] !font-normal placeholder:text-[12px] text-gray-600 bg-gray-200 border border-gray-300 rounded-md cursor-not-allowed"
                            value={bankDetails.branchName}
                            readOnly
                            disabled
                          />
                        </div>
                        <div className="flex flex-col">
                          <label className="text-[14px] font-normal mb-[2px]">City</label>
                          <input
                            type="text"
                            placeholder="City"
                            className="w-full p-[6px] !text-[14px] !font-normal placeholder:text-[12px] text-gray-600 bg-gray-200 border border-gray-300 rounded-md cursor-not-allowed"
                            value={bankDetails.city}
                            readOnly
                            disabled
                          />
                        </div>
                      </div>

                      <div className="flex justify-end mt-3">
                        <button
                          onClick={() => handleVerify("bank")}
                          disabled={isBankVerified}
                          className={`text-white text-[12px] py-2 px-3 rounded-md ${isBankVerified ? "bg-[#0CBB7D] cursor-not-allowed" : "bg-[#0CBB7D] hover:bg-[#0aa66c]"
                            }`}
                        >
                          {isBankVerified ? "Verified" : "Verify"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Image */}
                <div className="hidden md:flex items-start justify-center">
                  <div className="p-0 w-full max-w-[500px] md:-ml-[80px] mt-12">
                    <img
                      src={kycimage1}
                      alt="Bank Visual"
                      className="w-full h-auto max-h-[380px] object-contain rounded-md"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}





          {currentStep === 3 && (
            <div className="relative w-full text-[14px] lg:-mt-10 md:mt-0">
              {(isLoading || isVerifying) && (
                <div className="absolute inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10 rounded-md">
                  <span className="text-white font-semibold text-[12px]">Processing...</span>
                </div>
              )}

              <h2 className="text-[14px] text-[#0CBB7D] font-semibold mb-3">Document Verification</h2>

              <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${isLoading || isVerifying ? "pointer-events-none opacity-50" : ""}`}>

                {/* Aadhaar Left Side Box */}
                <div className="p-7 rounded-md shadow-md lg:shadow-[0_2px_8px_rgba(12,187,125,0.3)] bg-white">
                  <h3 className="font-semibold text-[#0CBB7D] mb-4 text-[14px]">Aadhaar Verification</h3>

                  <div className="grid grid-cols-2 gap-6">
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">Aadhar Number</label>
                      <input
                        type="text"
                        placeholder="Aadhar Number"
                        className="p-[6px] border border-gray-300 rounded-md text-[14px] placeholder:text-[12px] font-normal"
                        value={documentDetails.aadharNo}
                        onChange={(e) =>
                          setDocumentDetails({ ...documentDetails, aadharNo: e.target.value })
                        }
                        disabled={isLoading || isAadharVerified}
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">OTP</label>
                      <input
                        type="text"
                        placeholder="Enter OTP"
                        className="p-[6px] border border-gray-300 rounded-md text-[14px] placeholder:text-[12px] font-normal"
                        value={documentDetails.otp}
                        onChange={(e) =>
                          setDocumentDetails({ ...documentDetails, otp: e.target.value })
                        }
                        disabled={isLoading || isVerifying || isAadharVerified}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between mt-3">
                    <button
                      onClick={handleSendOtp}
                      className="bg-[#0CBB7D] text-white lg:p-[7px] text-[12px] rounded-md min-w-[40px]"
                      disabled={isAadharVerified || isLoading}
                    >
                      {isOtpSent ? "OTP Sent" : "Send OTP"}
                    </button>
                    <button
                      onClick={() => handleVerify("aadhar")}
                      className="bg-[#0CBB7D] text-white text-[12px] p-[7px] rounded-md min-w-[65px]"
                      disabled={isAadharVerified || isLoading || isVerifying}
                    >
                      {isAadharVerified ? "Verified" : "Verify"}
                    </button>
                  </div>

                  <div className="grid grid-cols-2 gap-6 mt-4">
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">Name</label>
                      <input
                        type="text"
                        placeholder="Name"
                        className="w-full p-[6px] border border-gray-300 rounded-md bg-gray-200 text-gray-600 cursor-not-allowed placeholder:text-[12px] font-normal"
                        value={documentDetails.name}
                        readOnly
                        disabled
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">Guardian Name</label>
                      <input
                        type="text"
                        placeholder="Guardian Name"
                        className="w-full p-[6px] border border-gray-300 rounded-md bg-gray-200 text-gray-600 cursor-not-allowed placeholder:text-[12px] font-normal"
                        value={documentDetails.guardianName}
                        readOnly
                        disabled
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-3 mt-4">
                    <label className="font-normal text-[14px]">Address</label>
                    <input
                      type="text"
                      placeholder="Address"
                      className="w-full p-[6px] border border-gray-300 rounded-md bg-gray-200 text-gray-600 cursor-not-allowed placeholder:text-[12px] font-normal"
                      value={documentDetails.address}
                      readOnly
                      disabled
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-6 mt-4">
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">State</label>
                      <input
                        type="text"
                        placeholder="State"
                        className="w-full p-[6px] border border-gray-300 rounded-md bg-gray-200 text-gray-600 cursor-not-allowed placeholder:text-[12px] font-normal"
                        value={documentDetails.state}
                        readOnly
                        disabled
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">City</label>
                      <input
                        type="text"
                        placeholder="City"
                        className="w-full p-[6px] border border-gray-300 rounded-md bg-gray-200 text-gray-600 cursor-not-allowed placeholder:text-[12px] font-normal"
                        value={documentDetails.city}
                        readOnly
                        disabled
                      />
                    </div>
                  </div>
                </div>

                {/* PAN Right Side Box */}
                <div className="p-7 rounded-md shadow-md lg:shadow-[0_2px_8px_rgba(12,187,125,0.3)] bg-white">
                  <h3 className="font-semibold text-[#0CBB7D] mb-4 text-[14px]">PAN Verification</h3>

                  <div className="grid grid-cols-2 gap-6">
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">PAN Number</label>
                      <input
                        type="text"
                        placeholder="PAN Number"
                        className="p-[6px] border border-gray-300 rounded-md text-[14px] placeholder:text-[12px] font-normal"
                        value={documentDetails.pan}
                        onChange={(e) =>
                          setDocumentDetails({ ...documentDetails, pan: e.target.value })
                        }
                        readOnly={isPanVerified}
                        disabled={isPanVerified}
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">Pan Type</label>
                      <input
                        type="text"
                        placeholder="Pan Type"
                        className="w-full p-[6px] border border-gray-300 rounded-md bg-gray-200 text-gray-600 cursor-not-allowed placeholder:text-[12px] font-normal"
                        value={documentDetails.panType}
                        readOnly
                        disabled
                      />
                    </div>
                  </div>

                  <div className="flex justify-between mt-3">
                    <button
                      onClick={() => handleVerify("pan")}
                      className={`bg-[#0CBB7D] text-white p-[7px] text-[12px] rounded-md min-w-[65px] ${isPanVerified ? "cursor-not-allowed" : ""
                        }`}
                      disabled={isPanVerified}
                    >
                      {isPanVerified ? "Verified" : "Verify"}
                    </button>
                  </div>

                  <div className="grid grid-cols-2 gap-6 mt-4">
                    <div className="flex flex-col gap-1">
                      <label className="font-normal text-[14px]">Name</label>
                      <input
                        type="text"
                        placeholder="Name"
                        className="w-full p-[6px] border border-gray-300 rounded-md bg-gray-200 text-gray-600 cursor-not-allowed placeholder:text-[12px] font-normal"
                        value={documentDetails.panName}
                        readOnly
                        disabled
                      />
                    </div>

                  </div>
                </div>
              </div>
            </div>
          )}


          {currentStep === 4 && (
            <div className="flex justify-center items-center w-full overflow-x-hidden mt-0 shadow-md lg:shadow-[0_2px_8px_rgba(12,187,125,0.3)] text-gray-600 text-[12px]">
              <div className="w-full lg:p-10 sm:p-3 mx-auto">
                {/* Heading */}
                <h2 className="text-[14px] sm:text-[14px] lg:text-[16px] text-[#0CBB7D] font-bold text-left">
                  Complete your KYC for a smoother delivery process!
                </h2>

                {/* Main Content Container */}
                <div className="bg-gray-50 border border-green-200 p-6 sm:p-4 rounded-lg shadow-inner space-y-4 mt-5 sm:mt-7 max-w-full mx-auto min-h-[300px] sm:min-h-[400px] lg:min-h-[300px] max-h-[400px] overflow-y-auto text-[12px] text-gray-600 font-normal text-justify lg:shadow-[0_2px_8px_rgba(12,187,125,0.3)] shadow-none">
                  <Aggrement
                    documentDetails={documentDetails}
                    companyAddress={companyAddress}
                    gstNumber={gstNumber}
                    billingInfo={billingInfo}
                  />

                  <div className="flex flex-wrap items-start gap-2">
                    <input
                      type="checkbox"
                      id="agree"
                      className="mt-1.5 h-4 w-4 text-[#0CBB7D] border-[#0CBB7D] rounded focus:ring-[#0CBB7D]"
                      checked={checked}
                      onChange={handleChecked}
                    />
                    <label
                      htmlFor="agree"
                      className="text-[12px] text-gray-600 mt-1.5 font-normal leading-snug"
                    >
                      By submitting this form, you agree to Shipex&apos;s User Privacy
                      Statement.
                    </label>
                  </div>

                  {/* {error && <p className="text-red-500 text-sm">{error}</p>} */}
                  {/* {verificationError && <p className="text-red-500 text-sm">{verificationError}</p>} */}
                </div>




                {/* Next Button */}
                {/* <div className="flex justify-end">
                  <button
                    onClick={handleNext}
                    className="px-6 sm:px-16 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 focus:ring-2 focus:ring-offset-2 focus:ring-green-500 mt-4 sm:mt-4"
                  >
                    Next
                  </button>
                </div> */}
              </div>
            </div>
          )}

          <div className="flex flex-row justify-between  items-center gap-4 mt-4 w-full">
            {currentStep > 0 && (
              <button
                className="bg-gray-500 hover:bg-gray-600 font-semibold rounded-md text-white py-[8px] px-[12px] text-[12px] rounded-lg transition flex items-center gap-1"
                onClick={handleBack}
              >
                <ArrowLeft className="w-4 h-4" /> Back
              </button>

            )}



            <button
              className={`py-[8px] px-[12px] text-[12px] rounded-md font-semibold transition flex items-center gap-1 
    ${(currentStep === 2 && !isBankVerified) ||
                  (currentStep === 3 && (!isAadharVerified || !isPanVerified))
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#0CBB7D] hover:bg-[#0CBB7D] text-white"
                }`}
              onClick={handleNext}
            >
              {currentStep < steps.length - 1 ? (
                <>
                  Next <ArrowRight className="w-4 h-4" />
                </>
              ) : (
                "Accept"
              )}
            </button>

          </div>

        </div>
      </div>
    </div>
  );
};

export default BusinessTypeSelection;